// Constantes career_status — statut produit alumni vs marché emploi.
//
// Source de vérité côté frontend pour les labels FR + couleurs de badges.
// Aligné sur backend/config/careerStatus.js (valeurs ENUM identiques).
//
// Si tu ajoutes une valeur ici, n'oublie pas de propager dans :
//   1. la migration backend (ALTER TABLE MODIFY COLUMN)
//   2. le modèle Sequelize ENUM
//   3. backend/config/careerStatus.js (VALUES)

export const CAREER_STATUS_VALUES = ['not_specified', 'open', 'actively_looking']

// Wording aligné Sprint 1.5 commit A (CareerStatusCard) :
//   - 'open' → "À l'écoute d'opportunités" (vs "Ouvert(e) aux opportunités",
//     plus naturel, écho au langage RH FR)
//   - 'not_specified' garde "Non précisé" car utilisé dans VerifyProfile signup
//     (select 3 options qui a besoin d'un libellé neutre). La nouvelle
//     CareerStatusCard affiche "Aucun statut sélectionné" à la place.
export const CAREER_STATUS_LABELS = {
  not_specified: 'Non précisé',
  open: "À l'écoute d'opportunités",
  actively_looking: 'En recherche active',
}

// null = pas de badge affiché (état neutre, silencieux).
// info    = signal discret bleu pour "ouvert mais pas en recherche".
// success = signal fort vert pour "recherche active". Vert (pas orange
//           warning) car c'est un état produit positif/intentionnel, pas
//           une alerte ni un problème ; cohérent avec le langage UI où
//           orange = avertissement à corriger.
export const CAREER_STATUS_BADGE_COLORS = {
  not_specified: null,
  open: 'info',
  actively_looking: 'success',
}

export const isValidCareerStatus = (value) => CAREER_STATUS_VALUES.includes(value)

// Label affichable d'un career_status. Avec `t` → i18n (business:career_status.<value>,
// fallback FR via defaultValue) ; sans `t` → map FR. Valeur inconnue → '' (caller décide).
// Affichage i18n centralisé — CAREER_STATUS_LABELS reste le fallback data-safe.
export const getCareerStatusLabel = (value, t) => {
  if (!value) return ''
  if (t) return t(`business:career_status.${value}`, { defaultValue: CAREER_STATUS_LABELS[value] || '' })
  return CAREER_STATUS_LABELS[value] || ''
}
